export function metricSpec(spec) {
    return spec;
}
//# sourceMappingURL=metrics.js.map